import { ReactNode, useEffect, useState } from 'react';
import { ThemeProvider } from '@emotion/react';
import { ThemeProvider as MaterialThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import createMaterialTheme from 'presentations/views/styles/material';
import { useRouter } from 'next/router';
import { appearanceCacheKey, Appearance } from '../styles/color';
import { getPersistentItem } from '../helpers/storage';
import { inDashboardUrl } from 'presentations/routes/helper';

interface Props {
  children?: ReactNode;
  service?: 'www' | 'gray';
}

export default function Compomnent(props: Props) {
  const service = props.service || 'www';
  const [isDarkable, setIsDarkable] = useState<boolean>(false);
  const [appearance, setAppearance] = useState<Appearance>(
    props.service === 'gray' ? Appearance.Gray : Appearance.Normal,
  );
  const router = useRouter();

  useEffect(() => {
    setIsDarkable(inDashboardUrl(router.asPath));
  }, [router]);

  useEffect(() => {
    if (props.service === 'gray') {
      setAppearance(Appearance.Gray);
      return;
    }
    let c = Appearance.Normal;
    if (isDarkable) {
      const value = getPersistentItem(appearanceCacheKey);
      if (value) {
        if (value && String(value) === Appearance.Dark) {
          c = Appearance.Dark;
        }
      }
    }
    setAppearance(c);
  }, [isDarkable, props.service]);

  const currentAppearance =
    isDarkable || props.service === 'gray' ? appearance : Appearance.Normal;

  return (
    <MaterialThemeProvider
      theme={createMaterialTheme({ appearance: currentAppearance })}
    >
      <ThemeProvider theme={{ service, appearance: currentAppearance }}>
        <CssBaseline />
        {props.children}
      </ThemeProvider>
    </MaterialThemeProvider>
  );
}
